import React, { useState } from "react";
import { Text, TextInput, TextInputProps, View } from "react-native";
import { useRsvpColors } from "../theme";

interface Props extends TextInputProps {
  label: string;
  error?: boolean;
}

/** Dark, rounded text input matching the RSVP kiosk aesthetic. */
const RsvpTextField: React.FC<Props> = ({ label, error, style, ...rest }) => {
  const colors = useRsvpColors();
  const [focused, setFocused] = useState(false);

  const borderColor = error
    ? rsvpTone_danger
    : focused
      ? colors.accent
      : colors.inputBorder;

  return (
    <View style={{ gap: 6 }}>
      <Text
        style={{
          color: colors.textSecondary,
          fontSize: 14,
          fontWeight: "500",
        }}
      >
        {label}
      </Text>
      <TextInput
        placeholderTextColor={colors.textFaint}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={[
          {
            backgroundColor: colors.inputBg,
            borderWidth: 1,
            borderColor,
            borderRadius: 12,
            paddingHorizontal: 16,
            paddingVertical: 14,
            color: colors.textPrimary,
            fontSize: 18,
          },
          style as any,
        ]}
        {...rest}
      />
    </View>
  );
};

const rsvpTone_danger = "#ef4444";

export default RsvpTextField;
